import React from 'react';
import { TableDataCase } from '../TableDataCase';
import { displayQuizDate } from 'helpers/table/quiz/displayQuiz';
import { QuizToNoteDef } from 'types/quizToNote/quizToNote';

export interface TableDataLineQuizProps {
  quiz: QuizToNoteDef;
}

export const TableDataLineQuiz = ({ quiz }: TableDataLineQuizProps) => {
  return (
    <tr>
      <TableDataCase variant={'data'} data={quiz.quiz.name} />
      <TableDataCase
        variant={'data'}
        data={displayQuizDate(quiz.quiz.debut, quiz.quiz.fin)}
      />
      <TableDataCase variant={'note'} data={quiz.note.toString()} />
    </tr>
  );
};
